import type { JSX, KeyboardEventHandler, ReactNode } from 'react'

import { useDraggable } from '@dnd-kit/core'
import { clsx } from 'clsx'

import { GripVerticalIcon, IconButton } from '@buffer-mono/popcorn'

import useDraggingCursor from '~publish/hooks/useDraggingCursor'

import styles from './CalendarUndatedDraftDragSource.module.css'

export function CalendarUndatedDraftDragSource({
  id,
  data,
  disabled,
  dragLabel,
  children,
}: {
  id: string
  data: Record<string, unknown>
  disabled: boolean
  dragLabel: string
  children: ReactNode
}): JSX.Element {
  const { attributes, listeners, setActivatorNodeRef, setNodeRef, isDragging } =
    useDraggable({ id, disabled, data })
  const { onKeyDown, ...mouseListeners } = listeners ?? {}
  const handleDragHandleKeyDown: KeyboardEventHandler = (event) => {
    onKeyDown?.(event)
  }
  useDraggingCursor(isDragging)

  return (
    <div
      {...mouseListeners}
      ref={setNodeRef}
      className={clsx(styles.draggable, {
        [styles.dragEnabled]: !disabled,
        [styles.dragging]: isDragging,
      })}
    >
      {children}
      {!disabled && (
        <IconButton
          variant="tertiary"
          size="small"
          label={dragLabel}
          className={styles.dragHandle}
          ref={setActivatorNodeRef}
          {...attributes}
          onKeyDown={handleDragHandleKeyDown}
          data-dnd
        >
          <GripVerticalIcon />
        </IconButton>
      )}
    </div>
  )
}

export function CalendarUndatedDraftDragOverlay({
  children,
}: {
  children: ReactNode
}): JSX.Element {
  return <div className={styles.overlay}>{children}</div>
}
